import React from 'react';
import './css/PlatformLanguageButton.css';

// Shared mobile language control: Welcome is the visual reference.
// Each page supplies its existing language-change handler.
const PlatformLanguageButton = ({ selectedLanguage, onToggle }) => {
  const spanish = selectedLanguage === 'spanish';
  return (
    <button
      type="button"
      className="tbp-mobile-language-button"
      aria-label={spanish ? 'Switch language to English' : 'Cambiar idioma a Español'}
      onClick={onToggle}
    >
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
        <path d="M3 12h18M12 3c3 3 4.4 6 4.4 9S15 18 12 21c-3-3-4.4-6-4.4-9S9 6 12 3Z" stroke="currentColor" strokeWidth="1.5" />
      </svg>
      {spanish ? 'English' : 'Español'}
    </button>
  );
};

export default PlatformLanguageButton;
